import React, { FunctionComponent } from 'react';
import { SignInPageLayout } from '../layout/SignInPageLayout';
import { PurchaseDiv } from '../component/purchase/PurchaseDiv';

interface Props {
  onChange: (e: any) => void;
}

export const PurchasePage: FunctionComponent<Props> = ({ onChange }) => (
  <SignInPageLayout centerDesktop={<PurchaseDiv onChange={onChange} />} />
);
